import { GenericCard } from '~src/app/spaces/CardView/GenericCard';
import { Messages } from '~src/codegen/Localize';
import { ExplorableItemDefinition, ContentTypeFilterClause } from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { DataAlerts } from '~src/dda/resources/DataAlerts';
import { ServerFilterClauses } from '~src/ts/helpers/ServerFilterClauses';
import { DataAlertContentType } from '~src/ts/models/ContentTypes';

import { getGenericDefaultFilters } from './getDefaultFilters';

export const DataAlertDefinition: ExplorableItemDefinition = {
  itemType: 'dataalert',
  pluralName: Messages.dataAlerts,
  singularName: Messages.dataAlert,
  emptyStateMessage: Messages.dataAlertsEmptyMessage,
  contentFilterKeys: DataAlertContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: GenericCard,
  listViewIconUrl: null,
  filterClause: ServerFilterClauses.ContentType(['dataalert']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return DataAlerts.all().withExtraParams(DataAlertContentType.extraQueryParams);
  },
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list'],
};
